import { filterByGenre, filterByCollection, filterByFeatured } from './lib/filters'
import { getDateDaysAgo } from './lib/getDateDaysAgo'
import { requestVideo, requestVideos } from './lib/requests'

export { filterByGenre }
export { filterByCollection }
export { filterByFeatured }

export const getVideo = (id, callback) => {
  requestVideo(id, null, callback)
}

export const getVideos = (callback) => {
  requestVideos(null, callback)
}

export const getVideosByCollection = (name, id, params, callback) => {
  let query = []

  query[`fields.${name}.sys.id`] = id

  if (params) {
    query = Object.assign(query, params)
  }

  requestVideos(query, callback)
}

export const getVideosRecentlyAdded = (callback) => {
  const createdAfter = getDateDaysAgo(31)

  const query = {
    'sys.createdAt[gte]': `${createdAfter}T00:00:00Z`
  }

  requestVideos(query, callback)
}

export const getVideosRecentlyReleased = (callback) => {
  const releasedAfter = getDateDaysAgo(31)

  const query = {
    'fields.releaseDate[gte]': `${releasedAfter}T00:00:00Z`
  }

  requestVideos(query, callback)
}



// WEBPACK FOOTER //
// ./src/common/contentful/index.js